// src/directives/smoothScroll.js
export default {
    mounted(el) {
        el.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    const offset = 90; // Adjust this value for the desired offset
                    const elementPosition = targetElement.getBoundingClientRect().top; // Distance from viewport top
                    const offsetPosition = elementPosition + window.scrollY - offset; // Adjusted position

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });
    },
};
